import React from 'react';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import AuthService from '../../services/AuthService';
import StorageService from '../../services/Storage';
import ComponetWithHeader from '../CompentWithHeader/ComponetWithHeader';
import ComponentWithoutHeader from '../ComponentWithoutHeader/ComponentWithoutHeader';
import ComponentWithoutSideNav from '../ComponentWithoutSideNav/ComponentWithoutSideNav';
import { Roles } from '../../constants/constant.role';

/**
 * private route component to prevent unauthorize access
 */
const PrivateRoute = ({ 
  component: Component, 
  sidenav, 
  header,
  footer = false, 
  isPrivateAndPublic, 
  routePermission 
}) => {
  const isAuthenticated = AuthService.isAuthenticated();

  if (isAuthenticated === true || isPrivateAndPublic) {
    let userDetail = StorageService.getUserDetail();
    let userRole = userDetail && userDetail.type ? userDetail.type : null;

    let permissions = [];

    if (userDetail && userDetail.permissions) {
      permissions = userDetail.permissions;
    }

    if (!isPrivateAndPublic) {
      if (!userRole) {
        AuthService.logout();
        return <Navigate to="/login" replace />;
      }

      let redirectToPage = false;

      if (routePermission && routePermission.length > 0) {
        for (let i = 0; i < permissions.length; i++) {
          if (permissions.includes(routePermission[0])) {
            redirectToPage = true;
            break;
          }
        }
      } else {
        // If no permission required, allow access
        redirectToPage = true;
      }

      if (!redirectToPage) {
        if ((userRole === Roles.FLEET_MANAGER_ROLE || userRole === Roles.ZONAL_FLEET_MANAGER_ROLE)) {
          return <Navigate to="/" replace />;
        } else {
          if (userDetail && userDetail.is_login_first_time === true) {
            return <Navigate to="/on-boarding" replace />;
          } else {
            return <Navigate to="/" replace />;
          }
        }
      }
    }

    // Check if first-time fleet user
    if (userDetail && userRole === Roles.FLEET_ROLE && userDetail.is_login_first_time === true) {
      return <Navigate to="/on-boarding" replace />;
    }

    // Adjust header/sidenav for public routes when not authenticated
    if (isPrivateAndPublic && !isAuthenticated) {
      header = !isPrivateAndPublic;
      sidenav = !isPrivateAndPublic;
    }

    // Render with appropriate layout
    if (header === true && sidenav === true && userDetail && !userDetail.temp_fleet) {
      return <ComponetWithHeader component={Component} footer={footer} />;
    } else if (header === true && sidenav === false) {
      return <ComponentWithoutSideNav component={Component} />;
    } else {
      return <ComponentWithoutHeader component={Component} />;
    }
  } else {
    return <Navigate to="/login" replace />;
  }
};

PrivateRoute.propTypes = {
  component: PropTypes.any.isRequired,
};

export default PrivateRoute;
